import { useSelector } from 'react-redux';
import './auth.component.scss';
import logo from '../../src/assets/logos/logo_white-old.png';
import { Header } from './Common/Header/Header';
import loaderImage from '../assets/images/animation_loader.gif';

export const AuthLayout = ({ children }) => {
  // const path = useLocation()
  const authReducer = useSelector((state) => state.authReducer);
  const loaderReducer = useSelector((state) => state.loaderReducer);

  if (!authReducer.isLogin || sessionStorage.getItem('isLogin') === 'false') {
    return (
      <>
        <div className="d-flex flex-column flex-root">
          <div
            className="d-block d-md-flex  blockForBigScreen  h-100"
            id="kt_login"
            style={{ minHeight: '100vh' }}
          >
            <div
              className="d-flex flex-column flex-lg-row-auto col-12 col-sm-12 col-md-5"
              style={{ minHeight: '100vh' }}
            >
              <div className="lading_page_background_img h-100">
                <div className="d-flex flex-column-auto flex-column text-center mb-md-5 logoContainer">
                  <span className="align-self-md-start text-start my-3 ms-3">
                    <img alt="logo" src={logo} className="img-fluid w-70" />
                  </span>
                </div>
                <div className="d-flex flex-column justify-content-center  align-items-center loginImgContainer">
                  <div className="d-flex flex-center align-content-between">
                    <div
                      className="img-fluid w-75 px-4 py-12"
                      style={{ fontSize: '120px' }}
                    >
                      {' '}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="login-content align-self-center  flex-lg-row-fluid d-flex flex-column justify-content-center h-100 py-10 px-10 p-lg-7 mx-auto w-100 bg-white">
              <div className="flex-column-fluid flex-center py-10  py-10 py-lg-20  p-xxxl-7 mx-auto mw-550px w-100 h-100 routerContainer">
                {children}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div
          className="animatedLoader h-100 "
          style={{
            display: loaderReducer.loader ? 'flex' : 'none',
            position: loaderReducer.loader ? 'fixed' : 'static',
          }}
        >
          <img
            alt="loader"
            loading="lazy"
            src={loaderImage}
            className="loaderImg"
          />
        </div>
        <div className="screen-container">
          <Header />
          <div className="content px-4">{children}</div>
        </div>
      </>
    );
  }
};
